import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  userData: {},
};

const persistDataSlice = createSlice({
  name: "persistInfo",
  initialState,
  reducers: {
    addPersistLoginInfo(state, action) {
      // console.log("Persist data",action.payload)
      state.userData = action?.payload?.data;
    },
    addPersistUserInfo(state, action) {
      // console.log("Persist data",action.payload)

      state.userData = { ...state.userData, ...action?.payload?.data };
      // console.log("state.userData",state.userData)
    },
   
    clearPersistData(state) {
      state.userData = {};
    },
    
  },
});

export const { addPersistLoginInfo ,addPersistUserInfo,clearPersistData } =  persistDataSlice.actions;

export default persistDataSlice.reducer;
